/* Shared product-page Buy now. Keep existing cart handling and availability rules.
   Filename retained for the existing theme asset; no product ID is hardcoded. */
(() => {
  if (window.asProductBuyNowLoaded) return;
  window.asProductBuyNowLoaded = true;
  const selector = '#MainContent .product-details product-form-component';
  const states = new Map();
  let scanQueued = false;

  function sync(component, state) {
    const block = component.querySelector('[data-as-product-buy-now]');
    const button = block?.querySelector('button[name="checkout"]');
    if (!block || !button) return;
    const addButton = component.querySelector('add-to-cart-component [ref="addToCartButton"]');
    const variantId = component.querySelector('input[name="id"]')?.value;
    const available = Boolean(variantId && addButton && !addButton.disabled);
    const disabled = !available || state.pending;
    if (button.disabled !== disabled) button.disabled = disabled;
    button.setAttribute('aria-busy', String(state.pending));
    if (block.hasAttribute('hidden')) block.removeAttribute('hidden');
    if (!button.textContent.trim()) button.textContent = 'Buy now';
    const status = block.querySelector('[data-as-buy-now-status]');
    const hideStatus = available || state.pending;
    if (status && status.hidden !== hideStatus) status.hidden = hideStatus;
  }

  function mount(component) {
    if (states.has(component) || !component.querySelector('[data-as-product-buy-now]')) return;
    const controller = new AbortController();
    const state = { controller, pending: false, generation: 0, queued: false, observer: null };
    const scheduleSync = () => {
      if (state.queued) return;
      state.queued = true;
      queueMicrotask(() => {
        state.queued = false;
        if (component.isConnected) sync(component, state);
      });
    };
    state.observer = new MutationObserver(scheduleSync);
    state.observer.observe(component, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['disabled', 'hidden', 'value'],
    });
    // Avoid sending an old variant or losing ring-size/engraving properties while
    // the theme is waiting for the new variant's section response.
    component.closest('.shopify-section')?.addEventListener('shopify:product:select', (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      const sourceId = event.target.closest('variant-picker')?.dataset.productId;
      if (sourceId && sourceId !== component.dataset.productId) return;
      const generation = ++state.generation;
      state.pending = true;
      sync(component, state);
      Promise.resolve(event.promise).catch(() => undefined).then(() => {
        requestAnimationFrame(() => {
          if (!component.isConnected || generation !== state.generation) return;
          state.pending = false;
          sync(component, state);
        });
      });
    }, { signal: controller.signal });
    states.set(component, state);
    sync(component, state);
  }

  function scan() {
    scanQueued = false;
    for (const [component, state] of states) {
      if (!component.isConnected) {
        state.observer.disconnect();
        state.controller.abort();
        states.delete(component);
      }
    }
    document.querySelectorAll(selector).forEach(mount);
  }
  function scheduleScan() {
    if (scanQueued) return;
    scanQueued = true;
    queueMicrotask(scan);
  }
  function start() {
    scan();
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver((records) => {
      if (records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) =>
        node.nodeType === 1 && (node.matches?.('product-form-component') || node.querySelector?.('product-form-component'))
      ))) scheduleScan();
    }).observe(main, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', scheduleScan);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
